// App.js or Routes.js
import { useLocation } from 'react-router-dom';
import { useEffect } from 'react';
import NProgress from 'nprogress';
import 'nprogress/nprogress.css';

export default function RouteChangeLoader() {
  const location = useLocation();

  useEffect(() => {
    NProgress.start();
    // Simulate delay if needed
    const timeout = setTimeout(() => {
      NProgress.done();
    }, 300); // short delay to avoid flashing bar
    return () => clearTimeout(timeout);
  }, [location]);

  return null;
}
